"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function doge(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.56088 10.9575H12.7964V12.672H9.56088V16.2855H11.6016C12.4094 16.2855 13.0701 16.1768 13.5846 15.9578C14.0991 15.7395 14.5026 15.4372 14.7959 15.0502C15.0958 14.6478 15.3 14.1822 15.3929 13.689C15.5012 13.1326 15.554 12.5668 15.5504 12C15.554 11.4332 15.5012 10.8674 15.3929 10.311C15.3001 9.81772 15.0959 9.35214 14.7959 8.94975C14.5026 8.56275 14.0984 8.2605 13.5846 8.04225C13.0701 7.82325 12.4094 7.7145 11.6016 7.7145H9.56088V10.9583V10.9575ZM7.48638 12.672H6.37488V10.9583H7.48638V6H12.3981C13.3056 6 14.0909 6.1575 14.7546 6.47025C15.4184 6.7845 15.9599 7.21275 16.3806 7.7565C16.8006 8.2995 17.1134 8.9355 17.3181 9.66375C17.5229 10.392 17.6249 11.1712 17.6249 12C17.63 12.7892 17.5266 13.5753 17.3174 14.3363C17.1134 15.0638 16.8006 15.7005 16.3799 16.2435C15.9599 16.7873 15.4184 17.2155 14.7546 17.5297C14.0909 17.8432 13.3049 18 12.3981 18H7.48638V12.672Z", fill: color }));
}
exports["default"] = doge;
//# sourceMappingURL=doge.js.map